import VisaIcon from '../../../images/cards/Visa.svg'
import MasterCardIcon from '../../../images/cards/Mc.svg'
import DiscoverIcon from '../../../images/cards/Discover.svg'
import AmexIcon from '../../../images/cards/Amex.svg'
import JCBIcon from '../../../images/cards/JCB.svg'
import UnionPayIcon from '../../../images/cards/UnionPay.svg'
import DinersIcon from '../../../images/cards/Diners.svg'

// Todo move me
export type Card =
  | 'amex'
  | 'diners'
  | 'discover'
  | 'jcb'
  | 'mastercard'
  | 'unionpay'
  | 'visa'
  | 'unknown'

interface CardIconProps {
  cardType?: Card
}

export default function CardIcon({ cardType }: CardIconProps): JSX.Element {
  switch (cardType) {
    case 'visa':
      return <VisaIcon width="100%" />
    case 'amex':
      return <AmexIcon width="100%" />
    case 'diners':
      return <DinersIcon width="100%" />
    case 'discover':
      return <DiscoverIcon width="100%" />
    case 'jcb':
      return <JCBIcon width="100%" />
    case 'mastercard':
      return <MasterCardIcon width="100%" />
    case 'unionpay':
      return <UnionPayIcon width="100%" />
    case 'unknown':
    default:
      return <i className="fas fa-credit-card tw-text-2xl" />
  }
}
